import { Button, Col, message, Row, Typography } from 'antd'
import React, { useEffect } from 'react'
import { handleMyTax } from '../../../helper'
import './SelfEmployedStatus.css'
import { useMutateSMZConsent } from '../../../api/react-query/partners'
import { useStores } from '../../../Store/Store'
import KuperLink from '../../../components/UI/KuperLink'

const { Title } = Typography

export default function WaitingPartnerConsent ({ loading, handleUpdateScreen }) {
  const { partnerProfile } = useStores()

  const {
    mutate: mutateSMZConsent,
    data: dataSMZConsent,
    isSuccess: isSuccessSMZConsent,
    isError: isErrorSMZConsent,
    isLoading: isLoadingSMZConsent
  } = useMutateSMZConsent()

  useEffect(() => {
    if (isSuccessSMZConsent && dataSMZConsent?.isSuccess) {
      message.success('Запрос отправлен')
      partnerProfile.setPartnerProfile({
        ...dataSMZConsent.partner,
        ...(partnerProfile?.id ? { id: partnerProfile?.id } : {})
      })
      handleUpdateScreen && handleUpdateScreen(dataSMZConsent?.partner?.profile)
    } else if (isErrorSMZConsent || dataSMZConsent?.errorMessage) {
      message.error(dataSMZConsent?.errorMessage || 'Ошибка запроса проверки статуса')
    }
  }, [dataSMZConsent, isSuccessSMZConsent, isErrorSMZConsent])

  const handleClick = () => {
    mutateSMZConsent({})
  }

  return (
    <Row justify='space-between' className='selfEmployedStatus '>
      <Col span={24} className='info-block'>
        <Row>
          <Col span={24}>
            <Title level={3}>Остался последний шаг</Title>

            <p>
              Ваши данные проверены.
            </p>
            <p>
              Нажимая на кнопку "Продолжить", вы даете согласие на отправку запроса на партнёрство с Купером в приложении "Мой налог"
            </p>

            <p>
              Убедитесь, что ваш номер телефона соответствует номеру из вашего аккаунта в  "Мой налог"
            </p>

            <p>
              Если не соответствует, измените номер в приложении "Мой налог" или заполните форму <KuperLink /> и укажите номер телефона из вашего аккаунта в «Мой налог». Затем ждите звонка оператора для завершения регистрации
            </p>

            <p>
              Если возникнут сложности, звоните: 8 800 250 54 50
            </p>

          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <img src='/img/pencil.png' className='pencil' />
          </Col>
        </Row>
      </Col>

      <Col span={24} className='btn-block'>
        <Button
          className='btn-my-tax'
          size='large'
          block
          onClick={handleMyTax}
        >
          <img src='/img/fns.png' className='mr-3' />Перейти в «Мой налог»
        </Button>
        <Button
          block
          ghost
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20'
          onClick={handleClick}
          loading={loading || isLoadingSMZConsent}
          style={{ width: '100%' }}
        >
          Продолжить
        </Button>
      </Col>
    </Row>
  )
}
